import { useState, type FormEvent } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { supabase } from '@/lib/supabase'
import { Logo } from '@/components/ui/Logo'
import { FormField } from '@/components/ui/FormField'

export default function ForgotPassword() {
  const navigate = useNavigate()
  const [email,   setEmail]   = useState('')
  const [loading, setLoading] = useState(false)
  const [sent,    setSent]    = useState(false)
  const [error,   setError]   = useState('')

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    if (loading) return
    if (!email.trim()) { setError('Email is required.'); return }
    setError('')
    setLoading(true)
    try {
      const { error: resetError } = await supabase.auth.resetPasswordForEmail(email.trim(), {
        redirectTo: `${window.location.origin}/auth/reset-password`,
      })
      if (resetError) {
        // Don't reveal whether the email exists
        setSent(true)
      } else {
        setSent(true)
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', padding: '24px 16px', background: '#FAF6EF',
    }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 22 }}>
          <Logo size={60} onClick={() => navigate('/')} />
        </div>

        <div style={{
          background: '#fff', border: '1px solid rgba(27,42,74,0.08)',
          borderRadius: 18, padding: '28px 24px',
        }}>
          {sent ? (
            <>
              <div style={{ font: '600 22px Lora,serif', color: '#1B2A4A', textAlign: 'center' }}>
                Check your inbox
              </div>
              <div style={{ font: '400 14px/1.6 Inter,sans-serif', color: 'rgba(27,42,74,0.6)', textAlign: 'center', marginTop: 10 }}>
                If <strong>{email}</strong> is registered, we've sent a password reset link. It expires in 60 minutes.
              </div>
              <div style={{ marginTop: 20, textAlign: 'center' }}>
                <Link to='/login' style={{ font: '500 14px Inter,sans-serif', color: '#0F7C6C' }}>
                  Back to log in
                </Link>
              </div>
            </>
          ) : (
            <>
              <div style={{ font: '600 22px Lora,serif', color: '#1B2A4A', textAlign: 'center' }}>
                Reset your password
              </div>
              <div style={{ font: '400 13px Inter,sans-serif', color: 'rgba(27,42,74,0.55)', textAlign: 'center', marginTop: 5, marginBottom: 20 }}>
                Enter your email and we'll send a reset link
              </div>

              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                <FormField
                  label='Email'
                  type='email'
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder='you@example.com'
                  autoComplete='email'
                  required
                />
                {error && <div className='banner-error'>{error}</div>}
                <button type='submit' className='btn-primary' disabled={loading}>
                  {loading ? 'Sending…' : 'Send reset link'}
                </button>
              </form>

              <div style={{ font: '400 13px Inter,sans-serif', color: 'rgba(27,42,74,0.55)', textAlign: 'center', marginTop: 14 }}>
                <Link to='/login' style={{ fontWeight: 600, color: '#0F7C6C' }}>Back to log in</Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
